document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-seal-cart-accessory-offer]') : null;
  if (!(button instanceof HTMLButtonElement)) return;

  const scope = button.closest('.cart-drawer, main') || document;
  const benefit = scope.querySelector('details.seal-cart-ecoseal-benefit');
  const summary = benefit?.querySelector('summary');
  if (!benefit || !summary) return;

  event.preventDefault();
  benefit.open = true;
  summary.focus({ preventScroll: true });
  summary.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    block: 'center',
  });
});
